export const dropdownDatePickerContentTexts = {
  SAVE_BUTTON: 'Save',
  RESET_BUTTON: 'Clear All',
};
